import axios from 'axios'
import {getI18n} from "react-i18next";

const api = axios.create({
    baseURL: global.BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    },
    withCredentials:true
})

api.interceptors.request.use((config) => {
    config.headers["Accept-Language"] = getI18n().language;
    return config;
}, (error) => {
    return Promise.reject(error);
});

api.interceptors.request.use(
    config => {
        const user = JSON.parse(localStorage.getItem('user'))
        if (user && user.token) {
            config.headers['Authorization'] = user.token
        }
        return config
    },
    error => Promise.reject(error)
)

export const setInterceptors = (logOut) => {
    api.interceptors.response.use(function (response) {
        return response
    }, function (error) {
        if (error.response.status === 401) {
            logOut()
        }
        return Promise.reject(error)
    })
}
export default api



